module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargadorDerecha-di-ap-1f60946c.png";